// steps of evaluation scheme
export const REPORT = "REPORT";
export const GAPANALYSIS = "GAPANALYSIS";
export const ANALYSIS = "ANALYSIS";
export const DRIVERS = "DRIVERS";

export const CHANGE_STEP = "CHANGE_STEP";
export const CHANGE_ANALYSIS_TAB = "CHANGE_ANALYSIS_TAB";

export const PEER1_TAB = "PEER1_TAB";
export const PEER2_TAB = "PEER2_TAB";
export const PEER3_TAB = "PEER3_TAB";

export const FETCH_RESULT = "FETCH_RESULT";
export const FETCH_RESULT_SUCCESS = "FETCH_RESULT_SUCCESS";
export const FETCH_RESULT_FAILED = "FETCH_RESULT_FAILED";

export const FETCH_DRIVERS = "FETCH_DRIVERS";
export const FETCH_DRIVERS_SUCCESS = "FETCH_DRIVERS_SUCCESS";
export const FETCH_DRIVERS_FAILED = "FETCH_DRIVERS_FAILED";

export const FETCH_ALL_RESULT = "FETCH_ALL_RESULT";
export const FETCH_ALL_RESULT_SUCCESS = "FETCH_ALL_RESULT_SUCCESS";
export const FETCH_ALL_RESULT_FAILED = "FETCH_ALL_RESULT_FAILED";

export const FETCH_ADMIN_RESULT = "FETCH_ADMIN_RESULT";
export const FETCH_ADMIN_RESULT_SUCCESS = "FETCH_ADMIN_RESULT_SUCCESS";
export const FETCH_ADMIN_RESULT_FAILED = "FETCH_ADMIN_RESULT_FAILED";

export const DELETE_ADMIN_RESULT = "DELETE_ADMIN_RESULT";
export const DELETE_ADMIN_RESULT_SUCCES = "DELETE_ADMIN_RESULT_SUCCES";
export const DELETE_ADMIN_RESULT_FAILED = "DELETE_ADMIN_RESULT_FAILED";



// WEBPACK FOOTER //
// ./src/modules/results/constants.js